
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { ServerInterface, ServerRepositoryInterface, ServerType } from '@/services/Server/Interfaces';
import MigrateWebsiteGroupForm from '@/services/WebsiteGroup/forms/MigrateWebsiteGroupForm';
import UserPicker from '@/components/user/UserPicker.vue';
import WebsiteGroupPicker from '@/components/website/WebsiteGroupPicker.vue';
import { Exception } from 'sass';

@Component({
  components: { WebsiteGroupPicker, UserPicker },
  mixins: [Themeable],
  inject: ['serverRepository'],
})
export default class MigrateWebsiteGroupDialog extends Vue {
  @Prop() sourceServerId!: string;

  public visible: boolean = true;

  public loading: boolean = true;

  private serverRepository!: ServerRepositoryInterface;

  public mainServer: ServerInterface | undefined;

  public servers: ServerInterface[] = [];

  public form: WPXFormValue<MigrateWebsiteGroupForm> = new WPXFormValue<MigrateWebsiteGroupForm>(MigrateWebsiteGroupForm);

  public async created(): Promise<void> {
    try {
      const originServers = await this.serverRepository.getServersOfType(ServerType.ORIGIN);
      this.mainServer = originServers.find((s) => s._id === this.sourceServerId);
      if (!this.mainServer) {
        this.$errorDialog.show('Main Server not found');

        return;
      }

      this.form.data.originServerSource = this.mainServer._id;

      this.servers = originServers;

      this.loading = false;
    } catch (err) {
      this.$errorDialog.show(err?.response?.data?.message || err.message);
    }
  }

  public migrateGroup(): void {
    this.$emit('migrateGroup', this.sourceServerId, this.form.data.originServerTarget);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
